import '../Styles/ProjectsNavBar.css';
import { Link } from "react-router-dom";
import Arrow from "../Img/arrow.svg"
import Close from "../Img/close.svg"
import React, { useState } from "react"

function ProjectsNavBar(props) {

  const buttonClose = document.getElementById('ProjectsNavBar__Close');
  const buttonArrow = document.getElementById('ProjectsNavBar__Arrow');
  const menu = document.getElementById('ProjectsNavBar__menu');

  const [clicked, setClicked] = useState(false)

  function Click() {
    if (clicked === true) {
      setClicked(false)
    } else {
      setClicked(true)
    }
  }

  if (
    document.getElementById('ProjectsNavBar__Arrow') &&
    document.getElementById('ProjectsNavBar__Close') &&
    document.getElementById('ProjectsNavBar__menu')
  ) {
    if (clicked === true) {
      buttonClose.style.display = 'grid';
      buttonArrow.style.display = 'none';
      menu.style.display = 'grid';
    } else {
      buttonClose.style.display = 'none';
      buttonArrow.style.display = 'grid';
      menu.style.display = 'none';
    }
  }

  return (
    <div className="ProjectsNavBar">
        <div className="ProjectsNavBar__nav" onClick={Click} data-aos='fade-zoom-in' data-aos-duration='1500' data-aos-delay='500'>
          <p>{props.language === props.uk ? "About" : "Acerca de"}</p>
          <img id='ProjectsNavBar__Arrow' src={Arrow} alt="" />
          <img id='ProjectsNavBar__Close' src={Close} alt="" />
        </div>
        <div className="ProjectsNavBar__menu" id='ProjectsNavBar__menu' data-aos='fade-zoom-in' data-aos-duration='1500' data-aos-delay='1000'>
          {props.projects.map(projectData =>
            <div className="ProjectsNavBar__menuItem" data={projectData.data()} key={projectData.id} id={projectData.id} >
              <div></div>
              <Link className='ProjectsNavBar__menuItemLink' to={projectData.data().id}>{projectData.data().name}</Link>
            </div>
          )}
        </div>
    </div>
  );
}

export default ProjectsNavBar;